<template>
  <div class="group-setup">
    <v-progress-linear indeterminate color="orange" v-if="loading"></v-progress-linear>
    <v-layout row v-if="errors">
      <v-flex>
        <Alert @dismissed="onDismissed" :text="errors"></Alert>
      </v-flex>
    </v-layout>
    <v-card class="pa-5">
      <v-card-title dark>
        <h3 class="ma-2">Publishing News Letter</h3>
      </v-card-title>
      <v-divider></v-divider>
      <v-row>
        <v-col cols="6" md="6" sm="12">
          <v-file-input outlined dense filled v-model="form.document1" prepend-icon="mdi-paperclip"
            label="Printing and distributing"></v-file-input>
          <small>Max Size 500Kb </small>
        </v-col>
        <v-col cols="6" md="6" sm="12">
          <v-file-input outlined dense filled v-model="form.document2" prepend-icon="mdi-paperclip"
            label="Publishing through Electronic Media"></v-file-input>
          <small>Max Size 500Kb </small>
        </v-col>
      </v-row>
      <v-divider></v-divider>
      <v-card-actions v-if="!cpRole">
        <v-row>
          <v-col cols="12" md="9" xs="6"></v-col>
          <v-col cols="12" md="3" xs="6">
            <v-btn large color="success" depressed :disabled="loading || (!form.document1 && !form.document2)" block
              @click="submit()">Submit
              to Review</v-btn>
          </v-col>
        </v-row>
      </v-card-actions>
    </v-card>
    <Snackbars :text="successMsg" :snackbar="snackbar" :color="'success'" @classSnackbar="closeSnackbar" />
  </div>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
const { mapGetters } = createNamespacedHelpers("auth");
import Alert from "@/components/shared/Alert";
import Snackbars from "@/components/shared/Snackbars";
import { ActivityService } from "../../../services/activity-service.js";
import { checkError } from "@/config/errors.js";

export default {
  name: "groupSetUpFrom",

  components: { Alert, Snackbars },

  data: () => ({
    cpRole: false,
    loading: false,
    errors: null,
    snackbar: false,
    successMsg: "",
    form: {
      document1: null,
      document2: null,
    },
  }),

  mounted() { },

  computed: {
    ...mapGetters({
      member: "profile",
    }),
  },

  methods: {
    submit() {
      this.errors = null;
      this.loading = true;
      this.snackbar = false;
      let fd = new FormData();

      fd.append(
        "document1",
        this.form.document1
      );
      fd.append(
        "document2",
        this.form.document2
      );
      fd.append(
        "date",
        this.form.date
      );
      fd.append("month", this.$route.params.month);
      fd.append("key", "PUBLISH_NEWS_LETTER");

      let data = fd;
      ActivityService.submitActivity('news-letter', data)
        .then((response) => {
          this.loading = false;
          if (response.data.data) {
            this.$router.push("/activities/monthly");
          }
        })
        .catch((error) => {
          this.loading = false;
          let data = error.response.data;
          let errorOutput = checkError.errorFormatting(data);
          this.errors = errorOutput;
        });
    },

    onDismissed() {
      this.errors = null;
    },
    closeSnackbar() {
      this.snackbar = false;
    },
    reset() {
      this.form.name = "";
    },
  },
};
</script>
